import React from 'react'
import { BasicStatsItem } from '../index.styles';

const InfrastuctureFullScreen = () => {
  return (
    <BasicStatsItem style={{
      width: '100%',
      height: '100%',
      flex: '1',
    }}>
      <iframe title="PSD iframe" src="https://app.powerbi.com/view?r=eyJrIjoiOTY2MDlmZDEtM2Y0NS00YjE5LWExYmEtMzQzMjU5YmMxYmVmIiwidCI6ImU2MjQzNTFhLWViZGItNDUwMi1hNGEzLTRiZWI3OTYxODBlZiIsImMiOjl9" />
    </BasicStatsItem>
  )
}

export default InfrastuctureFullScreen